import { render, staticRenderFns } from "./CategoryPost.vue?vue&type=template&id=daa1027e&scoped=true&lang=pug&"
import script from "./CategoryPost.vue?vue&type=script&lang=js&"
export * from "./CategoryPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa1027e",
  null
  
)

export default component.exports